// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDelinquentClaimsBriefDto
 */
export interface IDelinquentClaimsBriefDto {
    /**
     * 
     * @type {boolean}
     * @memberof IDelinquentClaimsBriefDto
     */
    show_delinquent_claims_report?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsBriefDto
     */
    repayment_required_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsBriefDto
     */
    locked_purses_count?: number;
}

/**
 * Check if a given object implements the IDelinquentClaimsBriefDto interface.
 */
export function instanceOfIDelinquentClaimsBriefDto(value: object): value is IDelinquentClaimsBriefDto {
    return true;
}

export function IDelinquentClaimsBriefDtoFromJSON(json: any): IDelinquentClaimsBriefDto {
    return IDelinquentClaimsBriefDtoFromJSONTyped(json, false);
}

export function IDelinquentClaimsBriefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDelinquentClaimsBriefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'show_delinquent_claims_report': json['show_delinquent_claims_report'] == null ? undefined : json['show_delinquent_claims_report'],
        'repayment_required_count': json['repayment_required_count'] == null ? undefined : json['repayment_required_count'],
        'locked_purses_count': json['locked_purses_count'] == null ? undefined : json['locked_purses_count'],
    };
}

export function IDelinquentClaimsBriefDtoToJSON(json: any): IDelinquentClaimsBriefDto {
    return IDelinquentClaimsBriefDtoToJSONTyped(json, false);
}

export function IDelinquentClaimsBriefDtoToJSONTyped(value?: IDelinquentClaimsBriefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show_delinquent_claims_report': value['show_delinquent_claims_report'],
        'repayment_required_count': value['repayment_required_count'],
        'locked_purses_count': value['locked_purses_count'],
    };
}

